module.exports = __webpack_public_path__ + "public/Icons/surgeAdd.svg?672bb1f2";